import AssistantMessageContent from '../AssistantMessageContent'
import ChatThreadAssistantMessageBody from './ChatThreadAssistantMessageBody.jsx'

export default function ChatThreadAssistantContent(props) {
  const {
    currentAssistant,
    exchangeId,
    activeAssistantVersionIndex,
    answerActiveOrdinal,
    answerCount,
    answerCanPrev,
    answerCanNext,
    onAnswerPrev,
    onAnswerNext,
    startSpeech,
    onAgentQuestionSelect,
    showMessageActions,
    regen,
  } = props
  return (
    <AssistantMessageContent
      text={currentAssistant.text}
      refinementSourceText={currentAssistant.text}
      showActions={showMessageActions}
      alwaysShowActions={showMessageActions}
      revealKey={`${exchangeId}-ans-${activeAssistantVersionIndex}`}
      onReadAloud={startSpeech}
      versionLabel={`${answerActiveOrdinal + 1}/${answerCount}`}
      showVersionNav={answerCount > 1}
      onPrevVersion={onAnswerPrev}
      onNextVersion={onAnswerNext}
      prevDisabled={!answerCanPrev}
      nextDisabled={!answerCanNext}
      onTryAgain={regen.tryAgain}
      onThinkLonger={regen.thinkLonger}
      onSearchWeb={regen.searchWeb}
    >
      <ChatThreadAssistantMessageBody
        assistant={currentAssistant}
        onAgentQuestionSelect={onAgentQuestionSelect}
      />
    </AssistantMessageContent>
  )
}
